/* eslint-disable import/no-cycle */
import { all, takeEvery } from 'redux-saga/effects';
import * as events from '../events';

import {
  preLogin, postLogin, subscriberSelect, ssoEnroll,
} from './init';

import authenticateUser from './services/auth/authenticateUser';
import forgotLogin from './services/auth/forgotLogin';
import forgotPassword from './services/auth/forgotPassword';
import mfaSubmit from './services/auth/mfaSubmit';
import passwordReset from './services/auth/passwordReset';
import ssoLoginUser from './services/auth/ssoLoginUser';
import ssoEnrollSubmit from './services/auth/ssoEnrollSubmit';

// board
import createBoard from './createBoard';
import changeBoard from './changeBoard';
import copyBoard from './copyBoard';
import deleteBoard from './deleteBoard';
import favoriteBoard from './favoriteBoard';
import hideBoard from './hideBoard';
import rememberBoard from './rememberBoard';
import resetBoard from './resetBoard';
import saveBoard from './saveBoard';
import saveBoardSettings from './saveBoardSettings';

// chart
import createChart from './createChart';
import deleteChart from './deleteChart';

export default function* rootSaga() {
  yield all([
    // init
    yield takeEvery(events.START_APP, preLogin),
    yield takeEvery(events.USER_AUTHENTICATED, postLogin),
    yield takeEvery(events.AUTHENTICATE_USER, authenticateUser),
    yield takeEvery(events.FORGOT_LOGIN, forgotLogin),
    yield takeEvery(events.FORGOT_PASSWORD, forgotPassword),
    yield takeEvery(events.SSO_LOGIN_USER, ssoLoginUser),
    yield takeEvery(events.SUBSCRIBER_SELECT, subscriberSelect),
    yield takeEvery(events.SSO_ENROLL, ssoEnroll),
    yield takeEvery(events.SSO_ENROLL_SUBMIT, ssoEnrollSubmit),
    yield takeEvery(events.MFA_SUBMIT, mfaSubmit),
    yield takeEvery(events.PASSWORD_RESET, passwordReset),
    yield takeEvery(events.CHANGE_BOARD, changeBoard),
    yield takeEvery(events.COPY_BOARD, copyBoard),
    yield takeEvery(events.CREATE_BOARD, createBoard),
    yield takeEvery(events.DELETE_BOARD, deleteBoard),
    yield takeEvery(events.FAVORITE_BOARD, favoriteBoard),
    yield takeEvery(events.HIDE_BOARD, hideBoard),
    yield takeEvery(events.REMEMBER_BOARD, rememberBoard),
    yield takeEvery(events.RESET_BOARD, resetBoard),
    yield takeEvery(events.SAVE_BOARD, saveBoard),
    yield takeEvery(events.SAVE_BOARD_SETTINGS, saveBoardSettings),
    yield takeEvery(events.CREATE_CHART, createChart),
    yield takeEvery(events.DELETE_CHART, deleteChart),
  ]);
}
